import { createSelector } from '@ngrx/store';
import { IVisorState } from 'app/visor/shared/models/mapModels';
import { INotificationState } from '../reducers';
import { getVisorState } from './config-leaflet.selector';

export const getNotificationState = createSelector(getVisorState, (state: IVisorState) => state.notification);

export const getNotification = createSelector(getNotificationState, (state: INotificationState) => state.notification);

